<!-- Only Billing Admins can see this -->
<ng-container *ngIf="permsLoaded">
	<ng-container *ngIf="canBillingPage">

		<ng-container *ngIf="loading; else contentTpl">
			<div class="flex justify-center p-3">
				<p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
			</div>
		</ng-container>

		<!-- Content -->
		<ng-template #contentTpl>
			<ng-container *ngIf="tier as t; else emptyTpl">
				<div class="tier-bar">
					<div class="tier-row">
						<!-- Current Plan -->
						<div class="plan">
							Your Current Plan is:
							<span class="pill">{{ t.pricingTierName }}</span>
						</div>

						<!-- Groups Limit -->
						<div class="limit" *ngIf="showGroups">
							You have access to:
							<span class="pill accent">
                        {{ t.groupsLimit ?? 'N/A' }} Groups
                     </span>
						</div>

						<!-- AI Tasks Limit -->
						<div class="limit" *ngIf="showAiTasks">
							AI Tasks:
							<span class="pill accent">
                        {{ t.aiTasksLimit ?? 'Unlimited' }}
                     </span>
						</div>

						<!-- Instruction -->
						<div class="instruction">
							Tyalls will limit the number of available Groups, based on your Plan.
							You can upgrade your Plan at any time via
							<a routerLink="{{ this.billingPageLink }}" class="link">Billing</a>.
						</div>
					</div>
				</div>
			</ng-container>

			<ng-template #emptyTpl></ng-template>
		</ng-template>

	</ng-container>
</ng-container>
